// Formatters localizados pt-BR.
const BRL = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  maximumFractionDigits: 0,
});
const BRL_FULL = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  maximumFractionDigits: 2,
});
const NUM = new Intl.NumberFormat("pt-BR");
const DATE_SHORT = new Intl.DateTimeFormat("pt-BR", {
  day: "2-digit",
  month: "2-digit",
});
const DATE_LONG = new Intl.DateTimeFormat("pt-BR", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});
const DATETIME = new Intl.DateTimeFormat("pt-BR", {
  day: "2-digit",
  month: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
});

export const fmtBRL      = (n: number) => BRL.format(n ?? 0);
export const fmtBRLFull  = (n: number) => BRL_FULL.format(n ?? 0);
export const fmtNum      = (n: number) => NUM.format(n ?? 0);
// Helper: parses a date-only string "YYYY-MM-DD" as LOCAL time (não UTC).
// Sem isso, `new Date("2026-06-03")` é interpretado como UTC e em fuso BRT vira 02/06 21:00 BRT.
function parseDate(d: string | Date): Date {
  if (d instanceof Date) return d;
  // ISO date-only "YYYY-MM-DD" → constrói como local time (não UTC)
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(d);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return new Date(d);  // outros formatos (ISO completo com hora/tz) seguem padrão
}

export const fmtDate     = (d: string | Date | null) => (d ? DATE_LONG.format(parseDate(d)) : "—");
export const fmtDateShort= (d: string | Date | null) => (d ? DATE_SHORT.format(parseDate(d)) : "—");
export const fmtDateTime = (d: string | Date | null) => (d ? DATETIME.format(parseDate(d)) : "—");

export function fmtPct(n: number | null, withSign = true): string {
  if (n === null || n === undefined) return "—";
  const sign = n > 0 && withSign ? "+" : "";
  return `${sign}${n.toFixed(2).replace(".", ",")}%`;
}

export function changeClass(n: number | null, kind: "positive-good" | "negative-good" = "positive-good"): "up" | "down" | "flat" {
  if (n === null || n === undefined || Math.abs(n) < 0.1) return "flat";
  if (kind === "positive-good") return n > 0 ? "up" : "down";
  return n > 0 ? "down" : "up";
}
